// Mock data for HimalayanPOS landing page

export const NAV_LINKS = [
  { label: 'Home', href: '#home' },
  { label: 'Products & Services', href: '#products' },
  { label: 'Benefits', href: '#benefits' },
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Coverage Area', href: '#coverage' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'FAQs', href: '#faqs' },
  { label: 'Contact', href: '#contact' },
];

export const HERO_FEATURES = [
  { icon: 'ShieldCheck', title: '100% Secure', sub: 'Transactions' },
  { icon: 'Zap', title: 'Instant', sub: 'Settlements' },
  { icon: 'Headphones', title: '24/7 Local', sub: 'Support' },
  { icon: 'BadgePercent', title: 'Best Offers', sub: '& Schemes' },
];

export const AGENT = {
  name: 'Ashish Sharma',
  title: 'Premium Account Executive',
  tag: 'Your Local Premium Partner',
  phone: '+91 98058 89685',
  whatsapp: '+91 98058 89685',
  email: 'ashish.12@himalayanpos.com',
  coverage: 'Himachal Pradesh & Uttarakhand',
  hours: '09:00 AM - 09:00 PM',
  availability: 'Available 7 Days a Week',
};

export const TRUST_STATS = [
  { value: '1000+', label: 'Happy Merchants', icon: 'Users' },
  { value: '2500+', label: 'Smart POS Installed', icon: 'Smartphone' },
  { value: '20+', label: 'Cities Covered', icon: 'MapPin' },
  { value: '100%', label: 'Secure & Reliable', icon: 'ShieldCheck' },
  { value: '24/7', label: 'Local Support', icon: 'Headphones' },
];

export const POS_QUANTITIES = ['1', '2-5', '6-10', '11-25', '26-50', '50+', 'Not Sure'];

export const BUSINESS_TYPES = [
  'Retail Store',
  'Restaurant / Cafe',
  'Grocery / Kirana',
  'Pharmacy',
  'Hotel / Resort',
  'Salon / Spa',
  'Petrol Pump',
  'Electronics',
  'Apparel & Fashion',
  'Other',
];

export const DISTRICTS_HP = [
  'Shimla', 'Solan', 'Kangra', 'Mandi', 'Kullu', 'Hamirpur', 'Una', 'Bilaspur', 'Chamba', 'Sirmaur', 'Paonta Sahib', 'Kinnaur', 'Lahaul-Spiti',
];

export const DISTRICTS_UK = [
  'Dehradun', 'Haridwar', 'Rishikesh', 'Haldwani', 'Rudrapur', 'Kashipur', 'Nainital', 'Roorkee', 'Almora', 'Pithoragarh', 'Uttarkashi', 'Chamoli',
];

export const SOLUTIONS = [
  {
    icon: 'Smartphone',
    title: 'PhonePe Smart POS (EDC)',
    desc: 'Accept all digital payments with fast settlements and an easy to use device.',
    tag: 'Most Popular',
  },
  {
    icon: 'QrCode',
    title: 'PhonePe QR',
    desc: 'Accept payments using QR codes. Easy, secure and 100% contactless.',
    tag: 'Free Setup',
  },
  {
    icon: 'Speaker',
    title: 'PhonePe Soundbox',
    desc: 'Instant voice confirmation for every payment. Never miss a payment again.',
    tag: 'Bestseller',
  },
  {
    icon: 'Globe',
    title: 'Payment Gateway',
    desc: 'Accept online payments on your website or mobile app with a single integration.',
    tag: 'For Businesses',
  },
  {
    icon: 'Briefcase',
    title: 'Business Solutions',
    desc: 'Digital solutions to help you grow your business faster and smarter.',
    tag: 'Enterprise',
  },
];

export const BENEFITS = [
  { icon: 'Zap', title: 'Instant Activation', desc: 'Get your device up and running in less than 24 hours.' },
  { icon: 'Percent', title: 'Best MDR Rates', desc: 'Industry-leading Merchant Discount Rates for higher margins.' },
  { icon: 'LineChart', title: 'Live Analytics', desc: 'Track sales, settlements and trends in real time.' },
  { icon: 'Headphones', title: '24/7 Local Support', desc: 'Dedicated on-ground assistance in your city, any day.' },
  { icon: 'Gift', title: 'Exclusive Offers', desc: 'Access seasonal cashbacks and scheme benefits from PhonePe.' },
  { icon: 'TrendingUp', title: 'Business Growth', desc: 'Grow bigger with smart insights and merchant loans.' },
];

export const HOW_IT_WORKS = [
  { step: '01', title: 'Request a Demo', desc: 'Fill the form or ping us on WhatsApp - our team calls back within 15 minutes.' },
  { step: '02', title: 'Get Verified', desc: 'Share your basic KYC and shop details. We handle the paperwork end-to-end.' },
  { step: '03', title: 'Free Installation', desc: 'Our verified engineer installs and trains you on the device at your location.' },
  { step: '04', title: 'Start Accepting', desc: 'Go live within 24 hours and start accepting payments with confidence.' },
];

export const TESTIMONIALS = [
  {
    name: 'Rohit Thakur',
    role: 'Retail Store Owner',
    location: 'Shimla, HP',
    rating: 5,
    text: 'PhonePe Smart POS from HimalayanPOS boosted our digital payments by 60%. The support team is genuinely excellent and always available.',
    avatar: 'https://images.unsplash.com/photo-1774437790995-9a8513532a25',
  },
  {
    name: 'Neha Sharma',
    role: 'Cafe Owner',
    location: 'Solan, HP',
    rating: 5,
    text: 'Installation was quick and settlements are instant. Best decision we made for our business this year - highly recommended!',
    avatar: 'https://images.pexels.com/photos/26861411/pexels-photo-26861411.jpeg',
  },
  {
    name: 'Amit Kumar',
    role: 'Grocery Store',
    location: 'Dehradun, UK',
    rating: 5,
    text: 'The Soundbox is a game-changer. Never miss a payment now and my customers love the smooth checkout experience.',
    avatar: 'https://images.unsplash.com/photo-1774437790995-9a8513532a25',
  },
  {
    name: 'Priya Negi',
    role: 'Salon Owner',
    location: 'Nainital, UK',
    rating: 5,
    text: 'From QR to POS, everything works seamlessly. Ashish personally onboarded us and the offers are unmatched.',
    avatar: 'https://images.pexels.com/photos/26861411/pexels-photo-26861411.jpeg',
  },
];

export const FAQS = [
  {
    q: 'How long does it take to get a PhonePe Smart POS?',
    a: 'Our team typically activates and installs the Smart POS at your location within 24 to 48 hours from KYC approval.',
  },
  {
    q: 'What documents are required for onboarding?',
    a: 'You will need PAN card, Aadhaar, GST (if applicable), shop photograph, and a cancelled cheque or bank passbook copy.',
  },
  {
    q: 'Are there any hidden charges?',
    a: 'No. Our pricing is transparent - you only pay a nominal rental (waived under offers) and standard MDR. No hidden fees.',
  },
  {
    q: 'Do you offer instant settlement?',
    a: 'Yes. PhonePe supports T+0 instant settlements for eligible merchants so your money hits the bank the same day.',
  },
  {
    q: 'Which areas do you cover?',
    a: 'We cover all major districts of Himachal Pradesh and Uttarakhand with on-ground engineers for installation and support.',
  },
  {
    q: 'Do you provide a Soundbox as well?',
    a: 'Yes, PhonePe Soundbox with voice confirmations in multiple Indian languages is available with free doorstep installation.',
  },
  {
    q: 'Is customer support available in the local language?',
    a: 'Absolutely. Our local team assists you in Hindi, English and regional dialects for a truly local experience.',
  },
];

export const FOOTER_LINKS = {
  quick: [
    { label: 'Home', href: '#home' },
    { label: 'Products & Services', href: '#products' },
    { label: 'Benefits', href: '#benefits' },
    { label: 'FAQs', href: '#faqs' },
    { label: 'Contact Us', href: '#contact' },
  ],
  services: [
    { label: 'Smart POS (EDC)', href: '#products' },
    { label: 'QR', href: '#products' },
    { label: 'Soundbox', href: '#products' },
    { label: 'Payment Gateway', href: '#products' },
    { label: 'Other Solutions', href: '#products' },
  ],
  coverage: [
    { label: 'Himachal Pradesh', href: '#coverage' },
    { label: 'Uttarakhand', href: '#coverage' },
    { label: 'All Districts', href: '#coverage' },
  ],
};
